import type { SearchFilterOptions } from '../../types';
import { REGION_CATEGORY_MAP, regionDisplayLabel } from '../../constants/filterConstants';
import { modeLabelText } from '../SearchFilters';

const CATEGORY_LABELS: Record<string, string> = Object.fromEntries(
  Object.values(REGION_CATEGORY_MAP).flat().map((c) => [c.key, c.label]),
);

const chipCls = 'inline-flex items-center h-[26px] px-[9px] rounded-ctl bg-accent-tint text-accent-deep font-medium';

interface CogniScopeChipsProps {
  filters: SearchFilterOptions;
  /** null = the label-negotiations toggle is not offered (no chip). */
  draftsIncluded: boolean | null;
  filtersOpen: boolean;
  onToggleFilters: () => void;
  controlsId: string;
  /** US-Drugs@FDA live for this user: region chips read the new labels. */
  usFdaVisible?: boolean;
}

/** Read-only chips for the applied search scope, plus the Edit filters toggle. */
export default function CogniScopeChips({
  filters,
  draftsIncluded,
  filtersOpen,
  onToggleFilters,
  controlsId,
  usFdaVisible = false,
}: CogniScopeChipsProps) {
  const regions = filters.regions.length > 0 ? filters.regions.map((r) => regionDisplayLabel(r, usFdaVisible)).join(' · ') : 'All regions';
  const categories =
    filters.searchMode === 'labels' && filters.marketingCategories.length > 0
      ? filters.marketingCategories.map((k) => CATEGORY_LABELS[k] ?? k.toUpperCase()).join(' · ')
      : null;
  return (
    <div className="flex flex-wrap items-center gap-2 text-[13px]">
      <span className={chipCls}>{modeLabelText(filters.searchMode)}</span>
      <span className={chipCls}>{regions}</span>
      {categories && <span className={chipCls}>{categories}</span>}
      {draftsIncluded !== null && (
        <span className="inline-flex items-center h-[26px] px-[9px] rounded-ctl border border-line text-ink-2">
          {draftsIncluded ? 'Drafts included' : 'Drafts excluded'}
        </span>
      )}
      <button
        type="button"
        onClick={onToggleFilters}
        aria-expanded={filtersOpen}
        aria-controls={controlsId}
        className="px-1 text-[13px] text-accent hover:underline"
      >
        Edit filters
      </button>
    </div>
  );
}
